<template>
	<div id="OrdinaryUsers">
		<el-row type="flex" justify="end" align="middle" class="titleBox">
			<div>预定电话：010-88228159 | 010-88228179</div>
			<div style="margin-left:40px;margin-right:40px;">Email：mzhu@bloomagelive.com/mnliu@bloomagelive.com</div>
			<div class="title">Hi!{{ userMobile }} 你好！<span style="color:#B7A575;text-decoration:none;out-line: none" @click="goOut">「退出登录」</span></div>
		</el-row>
		<el-row type="flex" justify="center" class="topMes">
			<el-col :span="18" class="letFont">
				<h3>场馆档期</h3>
				<p>备注：</p>
				<p v-html="remark"></p>
			</el-col>
			<el-col :span="6" class="rightBox" v-if="userTypeShow==0">
				<div>
					<!-- <p>预定电话：010-88228159 | 010-88228179</p>
					<p>Email(1)：mzhu@bloomagelive.com</p>
					<p>Email(2)：mnliu@bloomagelive.com</p> -->
					<p class="actGuide" @click="showGuide">活动运营指南</p>
					<p class="actGuide" @click="showBookingInformation">活动信息预定</p>
				</div>
			</el-col>
			<el-col :span="6" v-else> </el-col>
		</el-row>
		<el-row type="flex" justify="center" class="center" style="height: 640px;">
			<el-col :span="2" class="centerLetFont centerLeft">
				<p :class="item.ischeckde==true?'conterLeftOn':''" :key="item.id" v-for="(item,index) in protocolSelectForm" @click="changeProtocol(index,item.selectId)">{{ item.name }}</p>
			</el-col>
			<el-col :span="21" class="centerRight">
				<el-row type="flex" justify="space-between" class="centerRightTitle">
					<el-col :span="6">
						<el-date-picker v-model="installationDay" type="month" placeholder="选择月" value-format="yyyy-MM" @change="getMonthData">
						</el-date-picker>
					</el-col>
					<el-col :span="6" class="clickWeek">
						<el-button-group>
							<el-button size="small" @click="changeMonth('pre')">上个月</el-button>
							<el-button size="small" @click="changeMonth('now')">本月</el-button>
							<el-button size="small" @click="changeMonth('next')">下个月</el-button>
						</el-button-group>
					</el-col>
				</el-row>
				<el-row style="padding-top:10px;" type="flex" justify="center">
					<el-col :span="3" v-for="(item,index) in weeks" :key="item.index" class="borComTitle calenderComTitle">
						{{item}}
					</el-col>
				</el-row>
				<!-- 内容 -->
				<el-row type="flex" justify="center">
					<el-col :span="3" v-for="(item,index) in dates1" :key="item.index" class="borComCenter1 borComCenter calenderComCenter"
					 :class="[item.backGround,item.isLastRow]" :style="(item.activityNames.length>1)?overflowS:''">
						<div v-if="item.isThisMonth">
							<div class="centerTitle">
								<p class="centerTitleP">{{item.date}}</p>
							</div>
							<div v-if="userTypeShow==0">
								<div class="centerTitlePCenter" v-for="(listItem,index) in item.activityNames">{{listItem.activityTypeName}}</div>
							</div>
							<div v-else>
								<div class="centerTitlePCenter" v-for="(listItem,index) in item.activityNames">
									<p>{{listItem.activityShort}}</p>
									<p>{{listItem.enterDate.slice(5,10)}}~{{listItem.outDate.slice(5,10)}}</p>
								</div>
							</div>
						</div>
					</el-col>
				</el-row>
				<el-row type="flex" justify="center">
					<el-col :span="3" v-for="(item,index) in dates2" :key="item.index" class="borComCenter2 borComCenter calenderComCenter"
					 :class="[item.backGround,item.isLastRow]" :style="(item.activityNames.length>1)?overflowS:''">
						<div v-if="item.isThisMonth">
							<div class="centerTitle">
								<p class="centerTitleP">{{item.date}}</p>
							</div>
							<div v-if="userTypeShow==0">
								<div class="centerTitlePCenter" v-for="(listItem,index) in item.activityNames">{{listItem.activityTypeName}}</div>
							</div>
							<div v-else>
								<div class="centerTitlePCenter" v-for="(listItem,index) in item.activityNames">
									<p>{{listItem.activityShort}}</p>
									<p>{{listItem.enterDate.slice(5,10)}}~{{listItem.outDate.slice(5,10)}}</p>
								</div>
							</div>
						</div>
					</el-col>
				</el-row>
				<el-row type="flex" justify="center">
					<el-col :span="3" v-for="(item,index) in dates3" :key="item.index" class="borComCenter3 borComCenter calenderComCenter"
					 :class="[item.backGround,item.isLastRow]" :style="(item.activityNames.length>1)?overflowS:''">
						<div v-if="item.isThisMonth">
							<div class="centerTitle">
								<p class="centerTitleP">{{item.date}}</p>
							</div>
							<div v-if="userTypeShow==0">
								<div class="centerTitlePCenter" v-for="(listItem,index) in item.activityNames">{{listItem.activityTypeName}}</div>
							</div>
							<div v-else>
								<div class="centerTitlePCenter" v-for="(listItem,index) in item.activityNames">
									<p>{{listItem.activityShort}}</p>
									<p>{{listItem.enterDate.slice(5,10)}}~{{listItem.outDate.slice(5,10)}}</p>
								</div>
							</div>
						</div>
					</el-col>
				</el-row>
				<el-row type="flex" justify="center">
					<el-col :span="3" v-for="(item,index) in dates4" :key="item.index" class="borComCenter4 borComCenter calenderComCenter"
					 :class="[item.backGround,item.isLastRow]" :style="(item.activityNames.length>1)?overflowS:''">
						<div v-if="item.isThisMonth">
							<div class="centerTitle">
								<p class="centerTitleP">{{item.date}}</p>
							</div>
							<div v-if="userTypeShow==0">
								<div class="centerTitlePCenter" v-for="(listItem,index) in item.activityNames">{{listItem.activityTypeName}}</div>
							</div>
							<div v-else>
								<div class="centerTitlePCenter" v-for="(listItem,index) in item.activityNames">
									<p>{{listItem.activityShort}}</p>
									<p>{{listItem.enterDate.slice(5,10)}}~{{listItem.outDate.slice(5,10)}}</p>
								</div>
							</div>
						</div>
					</el-col>
				</el-row>
				<el-row type="flex" justify="center" v-if="dates5.length!=0">
					<el-col :span="3" v-for="(item,index) in dates5" :key="item.index" class="borComCenter5 borComCenter calenderComCenter"
					 :class="[item.backGround,item.isLastRow]" :style="(item.activityNames.length>1)?overflowS:''">
						<div v-if="item.isThisMonth">
							<div class="centerTitle">
								<p class="centerTitleP">{{item.date}}</p>
							</div>
							<div v-if="userTypeShow==0">
								<div class="centerTitlePCenter" v-for="(listItem,index) in item.activityNames">{{listItem.activityTypeName}}</div>
							</div>
							<div v-else>
								<div class="centerTitlePCenter" v-for="(listItem,index) in item.activityNames">
									<p>{{listItem.activityShort}}</p>
									<p>{{listItem.enterDate.slice(5,10)}}~{{listItem.outDate.slice(5,10)}}</p>
								</div>
							</div>
						</div>
					</el-col>
				</el-row>
				<el-row type="flex" justify="center" v-if="dates6.length!=0">
					<el-col :span="3" v-for="(item,index) in dates6" :key="item.index" class="borComCenter6 borComCenter calenderComCenter"
					 :class="[item.backGround,item.isLastRow]" :style="(item.activityNames.length>1)?overflowS:''">
						<div v-if="item.isThisMonth">
							<div class="centerTitle">
								<p class="centerTitleP">{{item.date}}</p>
							</div>
							<div v-if="userTypeShow==0">
								<div class="centerTitlePCenter" v-for="(listItem,index) in item.activityNames">{{listItem.activityTypeName}}</div>
							</div>
							<div v-else>
								<div class="centerTitlePCenter" v-for="(listItem,index) in item.activityNames">
									<p>{{listItem.activityShort}}</p>
									<p>{{listItem.enterDate.slice(5,10)}}~{{listItem.outDate.slice(5,10)}}</p>
								</div>
							</div>
						</div>
					</el-col>
				</el-row>
			</el-col>
		</el-row>

		<!-- 活动运营指南 -->
		<el-dialog title="活动运营指南" :visible.sync="dialogVisible" width="60%">
			<ActivityOperationsGuide />
		</el-dialog>
		<!-- 活动信息预定 -->
		<el-dialog class="my-el-dialog" title="活动信息预定" :visible.sync="DVBookingInformation" width="96%">
			<BookingInformation @subOver="subOver" />
		</el-dialog>

		<FooterMes />
	</div>
</template>
<!--数据存贮交互，事件控制地区-->
<script>
	import ActivityOperationsGuide from "@/views/ActivityOperationsGuide";
	import BookingInformation from "@/views/BookingInformation";
	import FooterMes from "@/components/FooterMes.vue"; // 底部版权说明
	export default {
		name: 'OrdinaryUsers',
		components: {
			ActivityOperationsGuide,
			BookingInformation,
			FooterMes, //底部版权说明
		},
		data() {
			return {
				dialogVisible: false, //活动运营指南
				DVBookingInformation: false, // 活动信息预定
				userForm: {
					mobile: '',
					code: '',
				},
				dates1: [],
				userTypeShow: sessionStorage.getItem("userType"),
				dates2: [],
				dates3: [],
				dates4: [],
				dates5: [],
				dates6: [],
				userMobile: sessionStorage.getItem("userMobile"),
				initMonthAllData: [], //初始整理后的数据 用过tab 切换
				installationDay: this.$moment().format("YYYY-MM"),
				userIdentity: 1, // 用户身份 1 管理员 2 普通用户
				overflowS: { //有多个活动时 内容区域可滚动
					overflowY: 'scroll'
				},
				remark: "",
				weeks: ["日", "一", "二", "三", "四", "五", "六"],
				// 协议类型
				protocolSelectForm: [{
					id: 1,
					name: "全部",
					selectId: "0",
					ischeckde: true
				}, {
					id: 2,
					name: "已签协议",
					selectId: "3",
					ischeckde: false
				}, {
					id: 3,
					name: "待签协议",
					selectId: "2",
					ischeckde: false
				}, {
					id: 4,
					name: "可定档期",
					selectId: "22",
					ischeckde: false
				}, {
					id: 5,
					name: "可挑战档期",
					selectId: "1",
					ischeckde: false
				}, ],
			}
		},
		created() {
			const nowMonth = this.$moment().format("YYYY-MM");
			const sendData = {
				"curMonth": nowMonth,
			}
			this.init(sendData);
		},
		methods: {
			// 切换月份 上个月 本月 下个月
			changeMonth: function(type) {
				console.log(type);
				if (type == "pre") {
					const year = this.installationDay.slice(0, 4);
					const months = this.installationDay.slice(5);
					let nextDate = "";
					if (months == '01') {
						nextDate = (parseInt(year) - 1) + "-12";
					} else {
						const nextMonth = (parseInt(months) - 1).toString().length == 1 ? "0" + (parseInt(months) - 1) : (parseInt(
							months) - 1);
						nextDate = year + "-" + nextMonth;
					}
					console.log(nextDate);
					this.installationDay = nextDate;
				} else if (type == "now") {
					this.installationDay = this.$moment().format("YYYY-MM")
				} else if (type == "next") {
					const year = this.installationDay.slice(0, 4);
					const months = this.installationDay.slice(5);
					let nextDate = "";
					if (months == '12') {
						nextDate = (parseInt(year) + 1) + "-01";
					} else {
						nextDate = this.$moment([year, months]).add(0, 'months').format("YYYY-MM");
					}
					this.installationDay = nextDate;
				}
				const sendData = {
					"curMonth": this.installationDay,
				}
				this.init(sendData);
			},
			// 切换 协议状态
			changeProtocol: function(index, activityStatus) {
				const that = this;
				for (let i = 0; i < that.protocolSelectForm.length; i++) {
					that.protocolSelectForm[i].ischeckde = false;
				}
				that.protocolSelectForm[index].ischeckde = true;
				let usedMonthAllData = "";
				if (activityStatus == 0) {
					// 全部
					usedMonthAllData = JSON.parse(sessionStorage.getItem("WKSMonthAllData"));
				} else if (activityStatus == 1) {
					//可挑战档期 backGround: "bgBlue"
					usedMonthAllData = JSON.parse(sessionStorage.getItem("WKSMonthAllData"));
					usedMonthAllData.forEach((item, index) => {
						if (item.backGround != "bgBlue") {
							item.list = [];
							item.activityNames = [];
							item.backGround = "bgGray";
						}
					})
				} else if (activityStatus == 3) {
					//已签协议 backGround: "bgRed"
					usedMonthAllData = JSON.parse(sessionStorage.getItem("WKSMonthAllData"));
					usedMonthAllData.forEach((item, index) => {
						if (item.backGround != "bgRed") {
							item.list = [];
							item.activityNames = [];
							item.backGround = "bgGray";
						}
					})
				} else if (activityStatus == 2) {
					//待签协议 backGround: "bgOrange"
					usedMonthAllData = JSON.parse(sessionStorage.getItem("WKSMonthAllData"));
					usedMonthAllData.forEach((item, index) => {
						if (item.backGround != "bgOrange") {
							item.list = [];
							item.activityNames = [];
							item.backGround = "bgGray";
						}
					})
				} else if (activityStatus == 22) {
					//可定档期 backGround: "bgGreen"
					usedMonthAllData = JSON.parse(sessionStorage.getItem("WKSMonthAllData"));
					usedMonthAllData.forEach((item, index) => {
						if (item.backGround != "bgGreen") {
							item.list = [];
							item.activityNames = [];
							item.backGround = "bgGray";
						}
					})
				}
				this.dates1 = usedMonthAllData.slice(0, 7);
				this.dates2 = usedMonthAllData.slice(7, 14);
				this.dates3 = usedMonthAllData.slice(14, 21);
				this.dates4 = usedMonthAllData.slice(21, 28);
				if (usedMonthAllData.length == 35) {
					this.dates5 = usedMonthAllData.slice(28);
				} else if (usedMonthAllData.length == 42) {
					this.dates5 = usedMonthAllData.slice(28, 35);
					this.dates6 = usedMonthAllData.slice(35);
				}
			},
			submitForm: function() {
				var that = this;
				if (this.userForm.name == "") {
					this.$message({
						message: "请输入用户名！",
						type: 'warning'
					});
					return false;
				}
				if (this.userForm.pass == "") {
					this.$message({
						message: "请输入密码！",
						type: 'warning'
					});
					return false;
				}
				this.axiosGet(this.httpUrl + "admin/login", {
					name: this.userForm.name,
					password: this.userForm.pass
				}).then((response) => {
					var backData = response.data;
					if (backData.state == 0) {
						sessionStorage.setItem("WKSUser", that.userForm.name);
						sessionStorage.setItem("token", backData.token);
						sessionStorage.setItem("asideArr", JSON.stringify(backData.result));
						sessionStorage.setItem("cityArr", JSON.stringify(backData.city));
						this.$router.push({
							path: '/Home'
						});
					} else {
						this.$message({
							message: backData.message,
							type: 'warning'
						});
					}
				});
			},
			init(sendData) {
				const userType = sessionStorage.getItem("userType"); //0 普通用户 1 管理员
				sendData.userType = userType;
				const sendUrl = this.httpUrl + "HXXCStadiumPCService/stadium/getActivityCalendarList";
				let that = this;
				this.axiosGet(sendUrl, sendData).then((response) => {
					const MonthAllData = [];
					const usedData = response.data.result;
					const remarkNew = response.data.remark.remark.replace(/\n/g, '<br>');
					that.remark = remarkNew;
					Object.keys(usedData).forEach(function(key, i, v) {
						const dayObj = {
							"intiDate": key,
							"date": key.slice(8, 10),
							"list": usedData[key],
							"isThisMonth": true,
							"isLastRow": "",
						};
						MonthAllData.push(dayObj);
					});
					this.collatingDataMonth(MonthAllData);
					// 切换月份默认显示 全部
					for (let i = 0; i < that.protocolSelectForm.length; i++) {
						that.protocolSelectForm[i].ischeckde = false;
					}
					that.protocolSelectForm[0].ischeckde = true;
				});
			},
			// 返回活动类型
			returnActivityTypeName(activityType) {
				let activityTypeName = "";
				switch (activityType) {
					case 1:
						activityTypeName = "演唱会";
						break;
					case 2:
						activityTypeName = "体育赛事";
						break;
					case 3:
						activityTypeName = "家庭秀";
						break;
					case 4:
						activityTypeName = "品牌发布会";
						break;
					case 5:
						activityTypeName = "颁奖典礼";
						break;
					case 6:
						activityTypeName = "企业年会";
						break;
					case 20:
						activityTypeName = "其他";
						break;
					default:
						break;
				}
				return activityTypeName;
			},
			// 整理月份的数据
			collatingDataMonth(MonthAllData) {
				let that = this;
				const MonthFirstDay = this.installationDay + "-01"; //获取一个月第一天星期几
				const weekOfday = this.$moment(MonthFirstDay, 'YYYY-MM-DD').format('E'); //计算指定日期是这周第几天
				this.initMonthAllData = MonthAllData; //整理后 初始的数据结构
				// 添加 背景颜色是哪一个
				MonthAllData.forEach((item, index) => {
					if (item.list.length == 0) {
						item.backGround = "bgGreen";
						item.activityNames = [];
					} else {
						if (item.list[item.list.length - 1].activityStatus == 1) {
							//可挑战
							item.backGround = "bgBlue";
						} else if (item.list[item.list.length - 1].activityStatus == 2) {
							//待签约 橙色
							item.backGround = "bgOrange";
						} else if (item.list[item.list.length - 1].activityStatus == 3) {
							//已签约 红色
							item.backGround = "bgRed";
						}
						const activityNames = [];
						item.list.forEach((listItem, index) => {
							if (listItem.playTime.indexOf(item.intiDate) >= 0) {
								const outDate = that.$moment(listItem.outDate).subtract(1, 'days').format("YYYY-MM-DD HH:mm");
								const listObj = {
									"activityShort": listItem.activityShort,
									"enterDate": listItem.enterDate,
									"outDate": outDate,
									"activityTypeName": that.returnActivityTypeName(listItem.activityType)
								}
								activityNames.push(listObj);
							}
						})
						item.activityNames = activityNames;
					}
				})

				if (weekOfday != 7) {
					// 某月的第一天 不是星期日
					const emptyDataArr = new Array(parseInt(weekOfday)).fill({
						"date": "",
						"list": [],
						"activityNames": [],
						"isThisMonth": false,
						"isLastRow": "",
					});
					for (let n of emptyDataArr) {
						MonthAllData.unshift(n);
					}
				}
				const remainderData = MonthAllData.length % 7; //检查数据中的长度 是不是7的余数 如果有余数 则需要补全数组
				if (remainderData != 0) {
					const emptyDataArr = new Array(7 - remainderData).fill({
						"date": "",
						"list": [],
						"activityNames": [],
						"isThisMonth": false,
						"isLastRow": "",
					});
					for (let n of emptyDataArr) {
						MonthAllData.push(n);
					}
				}
				// 最后一行 添加 下边框
				MonthAllData.forEach((item, index) => {
					if (index + 1 > MonthAllData.length - 7) {
						item.isLastRow = "borComCenterRB";
					}
				})
				this.dates1 = MonthAllData.slice(0, 7);
				this.dates2 = MonthAllData.slice(7, 14);
				this.dates3 = MonthAllData.slice(14, 21);
				this.dates4 = MonthAllData.slice(21, 28);
				this.dates5 = [];
				this.dates6 = [];
				if (MonthAllData.length == 35) {
					this.dates5 = MonthAllData.slice(28);
				} else if (MonthAllData.length == 42) {
					this.dates5 = MonthAllData.slice(28, 35);
					this.dates6 = MonthAllData.slice(35);
				}
				sessionStorage.setItem("WKSMonthAllData", JSON.stringify(MonthAllData));
			},
			// 获取月份数据
			getMonthData() {
				const sendData = {
					"curMonth": this.installationDay,
				};
				this.init(sendData);
			},
			// 查看活动运营指南
			showGuide() {
				this.dialogVisible = true;
			},
			// 查看活动运营指南
			showBookingInformation() {
				this.DVBookingInformation = true;
				// this.$router.push({
				// 	path: '/BookingInformation',
				// });
			},
			// 查看活动运营指南
			subOver(val) {
				console.log(val);
				if (val) {
					// =true 只有从添加页面 保存成功后 会返回 true
					this.DVBookingInformation = false;
				}
			},
			// 退出
			goOut() {
				this.$confirm('确认退出?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					sessionStorage.setItem("isLogin", "false");
					this.$router.push({
						path: '/'
					});
				}).catch(() => {});
			}
		}
	}
</script>

<style scoped>
	#OrdinaryUsers {
		width: 100%;
		padding-bottom: 46px;
		position: relative;
	}

	.letFont {
		color:#FFF;
	}

	.letFont h3 {
		font-size: 30px;
	}

	.letFont p {
		font-size: 14px;
	} 
	.loginBox {
		width: 33%;
		background: #fff;
		max-height: 400px;
		padding: 34px;
		border-radius: 4px;
	}

	.center {
		width: 80%;
		margin: 0 auto;
		padding-top: 30px;
	}

	.centerLeft {
		height: 100%;
		margin-right: 16px;
	}

	.centerLeft p {
		width: 100%;
		text-align: center;
		line-height: 48px;
		height: 48px;
		background:#F7F7F7;
		margin-bottom: 6px;
	}

	.centerRight {
		overflow-y: scroll;
		background: #fff;
		/* box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.11); */
		border: 1px solid #EDEFF5;
		padding: 27px;
	}

	.rightBox {
		color: #B7A575;
		text-align: center;
		padding-top: 47px;
		font-size: 14px;
		padding-bottom: 30px;
		margin-left: 10px;
	}

	.fontMes {
		width: 100%;
		text-align: right;
		color: #B7A575;
		font-size: 8px;
		margin-top: -11px;
		margin-bottom: 11px;
	}

	.topMes {
		padding:0 10% 30px 10%;
		padding-top: 30px;
		background: url(../pic/img_bg3.jpg) no-repeat;
		background-size: 100% 100%;
	}

	.titleBox {
		font-size: 14px;
		height: 60px;
		background: #F7F7F7;
	}

	.title {
		margin-right: 10%;
	}

	.clickWeek {
		text-align: right;
	}

	.conterLeftOn {
		background: #B7A575 !important;
		color: #fff;
	}

	.centerRightTitle {
		padding-bottom: 10px;
		border-bottom: 1px solid #ccc;
	}

	.calendarHeader {
		width: 100%;
		text-align: center;
		margin-top: 20px;
		margin-bottom: 15px;
	}

	.actGuide {
		width: 50%;
		height: 48px;
		line-height: 48px;
		background:#fff;
		margin: 0 auto;
		margin-top: 10px;
	}

	.borComCenter1:last-child,
	.borComCenter2:last-child,
	.borComCenter3:last-child,
	.borComCenter4:last-child,
	.borComCenter5:last-child,
	.borComCenter6:last-child {
		border-right: 1px #ccc solid;
	}

	.calenderComTitle {
		text-align: center;
		height: 45px;
		line-height: 45px;
	}

	.borComCenter {
		border-top: 1px #ccc solid;
		border-left: 1px #ccc solid;
	}

	.borComCenterR {
		border-right: 1px #ccc solid;
	}

	.borComCenterRB {
		border-bottom: 1px #ccc solid;
	}

	.calenderComCenter {
		height: 90px;
		color: #000;
		font-size: 10px;
	}

	.centerTitle {
		display: flex;
		justify-content: space-between;
		padding: 0 5px;
	}

	.bgGreen {
		/* background: #038e75; */
		background: #fff;
	}

	.bgBlue {
		background: #4661BC;
	}

	.bgOrange {
		background: #F09837;
	}

	.bgRed {
		background: #DE5754;
	}

	.bgGray {
		background: #dcdcdc;
	}

	.centerTitleP {
		font-size: 24px;
		font-weight: bold;
	}

	.centerTitlePCenter {
		font-size: 12px;
		padding-left: 5px;
	}
	
	/deep/.my-el-dialog .el-dialog .el-dialog__body{
		padding:0;
	}
	/deep/.my-el-dialog .el-dialog{
		margin-top: 60px !important;
	}
</style>



// WEBPACK FOOTER //
// src/views/OrdinaryUsers.vue